import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";
import { useSetRecoilState } from "recoil";

import { BulkActionsPanel, useGenericExportBulkAction } from "@ryde/controls";
import { usePageContext } from "@ryde/redux";
import { bulkOperationsDrawerAF } from "@ryde/shared";

import {
  BaseDrawer,
  DrawerContentStyled,
  DrawerHeader,
} from "../../../drawers";

export const BulkOperationsDefaultDrawer: FC = () => {
  const { entity } = usePageContext();
  const { t } = useTranslation();
  const genericExportAction = useGenericExportBulkAction();

  const setBulkOperationsDrawerOpened = useSetRecoilState(
    bulkOperationsDrawerAF(entity),
  );

  const onCloseDrawer = useEvent(() => setBulkOperationsDrawerOpened(false));

  return (
    <BaseDrawer onCloseDrawer={onCloseDrawer}>
      <DrawerHeader
        title={t("general.BULK_ACTIONS")}
        onCloseDrawer={onCloseDrawer}
      />
      <DrawerContentStyled className="bulk-action-drawer">
        <BulkActionsPanel actions={[genericExportAction]} />
      </DrawerContentStyled>
    </BaseDrawer>
  );
};
